module.exports = __webpack_public_path__ + "img/book12.42eae4f6.jpg";